import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import logo from 'src/assets/images/logo.png?01022023'
import arrow from 'src/assets/images/arrow.svg'

const Header = () => {
  const [mobileNavOpen, setMobileNavOpen] = useState(false)

  const toggleMobileNav = () => {
    setMobileNavOpen(!mobileNavOpen)
  }
  const handleStartAssessment = () => {
    window.sessionStorage.removeItem('token')

    mobileNavOpen && setMobileNavOpen(false)
  }

  const location = useLocation()
  const isReportPage = /^\/report(\/.*)?$/.test(location.pathname)
  return (
    <header
      id="header"
      className={`header d-flex align-items-center fixed-top shadow ${
        mobileNavOpen ? 'mobile-nav-active' : ''
      }`}
    >
      <div className="container-fluid container-xl d-flex align-items-center w-100">
        <Link to="/" className="logo d-flex align-items-center me-auto">
          <img src={logo} alt="Company Logo" />
        </Link>
        {isReportPage ? (
          <div
            id="div_rptheader"
            className="div_rptheader"
            style={{
              backgroundColor: 'inherit',
              fontSize: '12px',
              paddingLeft: '30px',
              paddingRight: '20px',
            }}
          >
            <b>
              AssessFamilyLaw.org is a free resource designed to stimulate discussion about and
              improvements in family law systems in the United States, Canada, and ten other
              countries.
            </b>
          </div>
        ) : (
          <div id="div_rptheader" className="div_rptheader" />
        )}
        {!mobileNavOpen && (
          <i
            className="mobile-nav-toggle mobile-nav-show bi bi-list"
            onClick={toggleMobileNav}
            style={{ cursor: 'pointer' }}
          ></i>
        )}

        {mobileNavOpen && (
          <i
            className="mobile-nav-toggle mobile-nav-hide bi bi-x"
            onClick={toggleMobileNav}
            style={{ cursor: 'pointer' }}
          ></i>
        )}

        <div className="top_right_corner">
          <div className="ancilary-nav d-flex justify-content-end mobile-hide">
            <Link to="/startassessment" className="simple-button" onClick={handleStartAssessment}>
              Assess your jurisdiction
              <img src={arrow} alt="arrow" />
            </Link>
          </div>

          <nav id="navbar" className={`navbar ${mobileNavOpen ? 'navbar-mobile' : ''}`}>
            <ul>
              <li>
                <Link to="/privacy" onClick={() => setMobileNavOpen(false)}>
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/feedback" onClick={() => setMobileNavOpen(false)}>
                  Your Feedback
                </Link>
              </li>
              <li>
                <Link to="/contactus" onClick={() => setMobileNavOpen(false)}>
                  Contact Us
                </Link>
              </li>
              <li>
                <Link
                  to="/startassessment"
                  className="simple-button mobile-show"
                  onClick={handleStartAssessment}
                >
                  Assess your jurisdiction
                  <img src={arrow} alt="arrow" />
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </header>
  )
}

export default Header
